module.exports = __webpack_public_path__ + "static/media/ge.49d8c528.png";